import React from 'react';
import dayjs from 'dayjs';
import { Card } from '@avila-tek/ui/src';
import { Title } from '../../shared';
import { Order } from '../../../models';
import { orderStatusTranslate } from '../../../static/orderStatus';
import { paymentStatusTranslate } from '../../../static/paymentStatus';
import Badge from '../../shared/Badge';

interface OrderInfoProps {
  order: Order;
}

function OrderInfo({ order }: OrderInfoProps) {
  return (
    <Card className="p-4 sm:px-6 relative">
      <div className="space-y-1 flex flex-col">
        <Title title="Detalles de la orden" />
        <span className="text-neutral-warm-500">Pedido realizado</span>
        <span className="text-text-gray text-lg font-semibold">
          {dayjs(order.createdAt).format('L')}
        </span>
        <span className="text-neutral-warm-500">Estatus</span>
        <Badge
          bgClassName={`
            ${
              order.status === 'cancelled' ? 'bg-warning-100' : 'bg-success-100'
            }`}
          textClassName={`
          ${
            order.status === 'cancelled'
              ? 'text-warning-300'
              : 'text-success-300'
          }`}
          text={orderStatusTranslate[order.status]}
        />
        <div className="text-neutral-warm-500 ">Pago</div>
        <Badge
          bgClassName="bg-success-100"
          textClassName="text-success-300"
          text={paymentStatusTranslate[order.paymentStatus]}
        />
      </div>
    </Card>
  );
}

export default OrderInfo;
